export default __webpack_public_path__ + "static/media/icon_plus_white.d0a58f35.svg";